import { RSAA } from 'redux-api-middleware';
import { fetchCase } from '../cases/actions';
import { getQueryStringValueByName, checkEmptyFieldValue } from '../../utils';
import { CASE_ID, ACCESS_TOKEN } from '../../utils/constants';
import { fetchCustomers } from '../customers';

export const FETCH_CONFIG = 'FETCH_CONFIG';
export const FETCH_CONFIG_SUCCESS = 'FETCH_CONFIG_SUCCESS';
export const FETCH_CONFIG_FAILED = 'FETCH_CONFIG_FAILED';

export const CSS_LOADING = 'CSS_LOADING';

export const updateCSSLoading = (isLoaded) => {
  return {
    type: CSS_LOADING,
    isCssLoaded: isLoaded
  };
};

export const fetchConfig = (configPath = './config.json') => ({
  [RSAA]: {
    endpoint: configPath,
    method: 'GET',
    types: [
      {
        type: FETCH_CONFIG,
        meta: {
          loading: true
        }
      },
      {
        type: FETCH_CONFIG_SUCCESS,
        meta: () => {
          const caseId = getQueryStringValueByName(CASE_ID);
          const token = getQueryStringValueByName(ACCESS_TOKEN);
          if (checkEmptyFieldValue(caseId)) {
            return { nextAction: fetchCase(), loading: true };
          } else if (checkEmptyFieldValue(token)) {
            return { nextAction: fetchCustomers(), loading: true };
          }
          return { loading: false };
        }
      },
      {
        type: FETCH_CONFIG_FAILED,
        meta: {
          loading: false
        }
      }
    ]
  }
});
